/**
 * Returns a replacement voice id when the draft's voice is not in the list, or
 * null to keep it. While the live voice list is still loading, the list holds
 * fallback ids that never match a saved Supabase voice UUID, so reconciling
 * then would replace the user's chosen voice with a random one.
 */
export function reconcileVoiceId(
  currentId: string | undefined,
  voices: ReadonlyArray<{ id: string }>,
  liveVoicesLoaded: boolean,
  pick: (voices: ReadonlyArray<{ id: string }>) => string
): string | null {
  if (!liveVoicesLoaded || voices.length === 0) return null
  if (voices.some((v) => v.id === currentId)) return null
  return pick(voices)
}
